import $ from 'jquery';

let productDetailTableOriginalNumbers = $( '.product-detail__table-original-show-only-3 tr:nth-child(n + 4)' );

$( ".product-detail__table-original--click" ).on('click', function () {
	if ( $( "#product-detail__table-original-more" ).hasClass( 'product-detail__table--active' ) ) {
		$( "#product-detail__table-original-more" ).removeClass( 'product-detail__table--active' );
		$( "#product-detail__table-original-less" ).addClass( 'product-detail__table--active' );
		productDetailTableOriginalNumbers.css( 'display', 'table-row' );
		$( '.product-detail__table-original-show-only-3').addClass('show-more-children');
		$( '.product-detail__table-original-show-only-3').removeClass('show-only-3');
	} else {
		$( "#product-detail__table-original-more" ).addClass( 'product-detail__table--active' );
		$( "#product-detail__table-original-less" ).removeClass( 'product-detail__table--active' );
		$( '.product-detail__table-original-show-only-3').addClass('show-more-children');
		$( '.product-detail__table-original-show-only-3').removeClass('show-only-3');
		productDetailTableOriginalNumbers.hide();
	}
} );

let $productDetailTableApplications = $( '.product-detail__table-applications-show-only-3 tr:nth-child(n + 4)' );
let $productDetailTableApplicationsMore = $( '#product-detail__table-applications--more' );
let $productDetailTableApplicationsLess = $( '#product-detail__table-applications--less' );

$( '.product-detail__table-applications--click' ).on('click', function() {
	if ( $productDetailTableApplicationsMore.hasClass( 'product-detail__table--active' ) ) {
		$productDetailTableApplicationsMore.removeClass( 'product-detail__table--active' );
		$productDetailTableApplicationsLess.addClass( 'product-detail__table--active' );
		$productDetailTableApplications.css( 'display', 'table-row' );
		$( '.product-detail__table-applications-show-only-3').addClass('show-more-children');
		$( '.product-detail__table-applications-show-only-3').removeClass('show-only-3');
	} else {
		$productDetailTableApplicationsMore.addClass( 'product-detail__table--active' );
		$productDetailTableApplicationsLess.removeClass( 'product-detail__table--active' );
		$( '.product-detail__table-applications-show-only-3').addClass('show-only-3');
		$( '.product-detail__table-applications-show-only-3').removeClass('show-more-children');
		$productDetailTableApplications.hide();
	}
} );